import {
    ApartmentOutlined,
    ContactlessOutlined,
    CurrencyExchangeOutlined,
    DescriptionOutlined,
    HolidayVillageOutlined,
    InsertInvitationOutlined,
    LabelOutlined,
    PaidOutlined,
    PeopleOutlineOutlined,
    PersonOutlined,
    PriceChangeOutlined,
    PublicOutlined,
    SignpostOutlined,
} from '@mui/icons-material';
import { CountryFilter, TextFilter } from './Components';
import { countriesOptions } from '@utils/globalOptions';
import LabelFilter from './Components/LabelFilter';

export const donationFilters = [
    [
        {
            header: 'Donation Filters',
            filters: [
                {
                    name: 'donor_name',
                    Component: TextFilter,
                    label: 'Donor Name',
                    Icon: PersonOutlined,
                    filterOptions: ['icontains'],
                },
                {
                    name: 'amount',
                    Component: TextFilter,
                    label: 'Amount',
                    Icon: PriceChangeOutlined,
                    decimalPoints: 2,
                    filterOptions: ['gte', 'lte', 'iexact'],
                },
                {
                    name: 'currency',
                    Component: TextFilter,
                    label: 'Currency',
                    Icon: PaidOutlined,
                    filterOptions: ['in'],
                },
                {
                    name: 'payments',
                    Component: TextFilter,
                    label: 'Payments',
                    Icon: CurrencyExchangeOutlined,
                    filterOptions: ['gte', 'lte', 'iexact'],
                },
                {
                    name: 'payments_months',
                    Component: TextFilter,
                    label: 'Payments Charged',
                    Icon: CurrencyExchangeOutlined,
                    decimalPoints: 0,
                    filterOptions: ['gte', 'lte', 'iexact'],
                },
                {
                    name: 'payments_left',
                    Component: TextFilter,
                    label: 'Payments Left',
                    Icon: CurrencyExchangeOutlined,
                    decimalPoints: 0,
                    filterOptions: ['gte', 'lte', 'iexact'],
                },
                {
                    name: 'donation_method',
                    Component: TextFilter,
                    label: 'Donation Method',
                    Icon: ContactlessOutlined,
                    filterOptions: ['in'],
                },
                {
                    name: 'donation_status',
                    Component: TextFilter,
                    label: 'Donation Status',
                    Icon: ContactlessOutlined,
                    filterOptions: ['in'],
                },
                {
                    name: 'donation_type',
                    Component: TextFilter,
                    label: 'Donation Type',
                    Icon: CurrencyExchangeOutlined,
                    filterOptions: ['in'],
                },
                {
                    name: 'donation_date',
                    Component: TextFilter,
                    label: 'Donation Date',
                    Icon: InsertInvitationOutlined,
                    filterOptions: ['gte', 'lte', 'date'],
                },
                {
                    name: 'fundraiser_name',
                    Component: TextFilter,
                    label: 'Fandraiser',
                    Icon: PersonOutlined,
                    filterOptions: ['icontains'],
                },
                {
                    name: 'donation_notes',
                    Component: TextFilter,
                    label: 'Donation Notes',
                    Icon: DescriptionOutlined,
                    filterOptions: [
                        'icontains',
                        'iexact',
                        'istartswith',
                        'iendswith',
                    ],
                },
                {
                    name: 'donor_note',
                    Component: TextFilter,
                    label: 'Donor Notes',
                    Icon: DescriptionOutlined,
                    filterOptions: [
                        'icontains',
                        'iexact',
                        'istartswith',
                        'iendswith',
                    ],
                },
            ],
        },
    ],
];

export const contactFilters = [
    [
        {
            header: 'Contact Details',
            filters: [
                {
                    name: 'full_name',
                    Component: TextFilter,
                    label: 'Name',
                    Icon: PersonOutlined,
                    filterOptions: ['icontains', 'icontains!'],
                },
                {
                    name: 'labels__name',
                    Component: LabelFilter,
                    label: 'Label',
                    Icon: LabelOutlined,
                    filterOptions: ['in'],
                },
                // {
                //     name: 'connections__relationship',
                //     Component: TextFilter,
                //     label: 'Relationship',
                //     Icon: PeopleOutlineOutlined,
                //     filterOptions: [
                //         'icontains',
                //         'iexact',
                //         'istartswith',
                //         'iendswith',
                //         'icontains!',
                //         'iexact!',
                //     ],
                // },
                {
                    name: 'description',
                    Component: TextFilter,
                    label: 'Description',
                    Icon: DescriptionOutlined,
                    filterOptions: [
                        'icontains',
                        'iexact',
                        'istartswith',
                        'iendswith',
                        'icontains!',
                        'iexact!',
                    ],
                },
            ],
        },
    ],
    [
        {
            header: 'Address Details',
            filters: [
                {
                    name: 'country',
                    Component: CountryFilter,
                    label: 'Country',
                    Icon: PublicOutlined,
                    filterOptions: ['in'],
                    renderLabel: countryCode =>
                        countryCode.toCountryDisplayName(),
                },
                {
                    name: 'city',
                    Component: TextFilter,
                    label: 'City',
                    Icon: HolidayVillageOutlined,
                    filterOptions: [
                        'icontains',
                        'iexact',
                        'istartswith',
                        'iendswith',
                        'icontains!',
                        'iexact!',
                    ],
                    defaultLookup: 'iexact',
                },
                {
                    name: 'state',
                    Component: TextFilter,
                    label: 'State',
                    Icon: ApartmentOutlined,
                    filterOptions: [
                        'icontains',
                        'iexact',
                        'istartswith',
                        'iendswith',
                        'icontains!',
                        'iexact!',
                    ],
                    defaultLookup: 'iexact',
                },
                {
                    name: 'street',
                    Component: TextFilter,
                    label: 'Street',
                    Icon: SignpostOutlined,
                    filterOptions: [
                        'icontains',
                        'iexact',
                        'istartswith',
                        'iendswith',
                        'icontains!',
                        'iexact!',
                    ],
                },
            ],
        },
    ],
    // [
    //     {
    //         header: 'Contact Donations',
    //         filters: [
    //             {
    //                 name: 'donations__donation_date',
    //                 Component: TextFilter,
    //                 label: 'Donation Date',
    //                 Icon: InsertInvitationOutlined,
    //                 filterOptions: ['gte', 'lte', 'date'],
    //             },
    //             {
    //                 name: 'donations__amount',
    //                 Component: TextFilter,
    //                 label: 'Donation Amount',
    //                 Icon: PriceChangeOutlined,
    //                 decimalPoints: 2,
    //                 filterOptions: ['gte', 'lte', 'iexact', 'iexact!'],
    //             },
    //             {
    //                 name: 'donations__currency',
    //                 Component: TextFilter,
    //                 label: 'Donation Currency',
    //                 Icon: PaidOutlined,
    //                 filterOptions: ['in'],
    //             },
    //             {
    //                 name: 'donations__donation_type',
    //                 Component: TextFilter,
    //                 label: 'Donation Type',
    //                 Icon: CurrencyExchangeOutlined,
    //                 filterOptions: ['in'],
    //             },
    //             {
    //                 name: 'donations__donation_method',
    //                 Component: TextFilter,
    //                 label: 'Donation Method',
    //                 Icon: ContactlessOutlined,
    //                 filterOptions: ['in'],
    //             },
    //         ],
    //     },
    // ],
];

export const getContactFilterByName = (name: string) =>
    contactFilters
        .flat()
        .flatMap(({ filters }) => filters)
        .find(({ name: filterName }) => filterName === name);
